// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1755":"polyfills-css-shim","2076":"common","7278":"polyfills-dom","9329":"polyfills-core-js"}[chunkId] || chunkId) + ".js";
};